import DOMPurify from 'dompurify';

export class HtmlSanitizer {
  static sanitizeEmbedCode(code: string): string {
    const attrs = [
      'allow',
      'allowfullscreen',
      'alt',
      'aria-hidden',
      'autoplay',
      'class',
      'controls',
      'decoding',
      'default',
      'frameborder',
      'height',
      'kind',
      'label',
      'loading',
      'loop',
      'muted',
      'playsinline',
      'poster',
      'preload',
      'referrerpolicy',
      'sandbox',
      'scrolling',
      'sizes',
      'src',
      'srclang',
      'srcset',
      'type',
      'width',
    ];

    const tags = ['audio', 'embed', 'iframe', 'img', 'source', 'track', 'video'];

    // FORCE_BODY is required to prevent pushing script tags into <head>
    // KEEP_CONTENT preserves text nodes and formatting better
    const config = {
      ADD_TAGS: tags,
      ADD_ATTR: attrs,
      FORCE_BODY: true,
      USE_PROFILES: { html: true },
      KEEP_CONTENT: true,
    };

    // First sanitize to get clean HTML
    // Note: DOMPurify will normalize HTML (whitespace, attribute order, etc.) for security
    // This is necessary for security but may affect formatting
    let sanitized = DOMPurify.sanitize(code, config);

    // Add referrerpolicy to iframes that don't have it
    // We need to parse to add the attribute, but try to minimize formatting changes
    if (sanitized.includes('<iframe') && !sanitized.includes('referrerpolicy')) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sanitized;

      tempDiv.querySelectorAll('iframe').forEach((iframe) => {
        if (!iframe.hasAttribute('referrerpolicy')) {
          iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        }
      });

      sanitized = tempDiv.innerHTML;
    }

    return sanitized;
  }

  static stripAllTags(userInput: string): string {
    return DOMPurify.sanitize(userInput, {
      ALLOWED_TAGS: [],
    });
  }
}
